import {URIAndTrace} from "@commons/mapping/URIAndTrace";
import {FPNetDate} from "@commons/types";

export type TypeAttestatoINPS = "UNDEFINED" | "MALATTIA" | "RICOVERO" | "DIMISSIONI";

export interface GiustificativoAttestatoINPSRecord extends URIAndTrace {
    type: TypeAttestatoINPS;
    idAziendaMaster: number;
    idAziendaTabelle: number;
    idDip: number;
    idAttestato: string;
    codGiu: string;
    codGiuTemp: string;
    annullato: boolean;
    elaborato: boolean;
    giornataBloccata: boolean;
    giornoDt: FPNetDate;
}

export class GiustificativoAttestatoINPSRecord {
    static getKey = (that: GiustificativoAttestatoINPSRecord) => {
        return that.idAttestato + '_' + that.giornoDt!
    }
}